type Params = Record<
    string,
    string | number | boolean | ReadonlyArray<string | number | boolean> | null | undefined
>;

function makeSearchParams(params: Params) {
    const filledParams: Params = {};

    for (const [key, value] of Object.entries(params)) {
        if (typeof value === 'number' || value) {
            filledParams[key] = value;
        }
    }

    return new URLSearchParams(filledParams as Record<string, string>);
}

function stringifySearchParams(params: URLSearchParams) {
    return params.toString();
}

export function createPageFilterParams(params: Params) {
    const { page, size, sort, queryFields, ...filterParams } = params;

    return {
        searchParams: stringifySearchParams(makeSearchParams({ page, size, sort })),
        // don't send queryFilterParams field if no search query used
        filterParams: filterParams.query ? { ...filterParams, queryFields } : filterParams,
    };
}

export function createUrlSearchParams(params: Params) {
    return stringifySearchParams(makeSearchParams(params));
}
